import { CountryValues } from '../../models'
import { DOMESTIC_COUNTRY_ISO_CODES } from '../common/constants/constants'

export const filterDomesticCountries = (countryList: CountryValues[]) => {
  return countryList.filter((country) => !DOMESTIC_COUNTRY_ISO_CODES.includes(country.countryIsoCode))
}
